import { SexType } from '#types/confirmationForms';

export const SEX: SexType = {
  MALE: '남성',
  FEMALE: '여성'
};
